import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import CookiebarModal from "./cookiebar_modal";
import CookiesList from './cookies_data.json'

import { Container, Wrapper } from './styles'
import { RootState } from '../../store/modules/rootReducer'
import { changeUnderstood } from '../../store/modules/cookieAccept/action'

const CookieBar: React.FC = () => {
  const { understood } = useSelector((state: RootState) => state?.acceptCookies)
  const { acceptedCookies } = useSelector((state: RootState) => state.acceptCookies)
  const dispatch = useDispatch()
  // const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (understood) {
      CookiesList.forEach((item) => {
        if (!acceptedCookies.marketing && item.category === 'Marketing')
          return (document.cookie = `${item.key_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`)
        if (!acceptedCookies.analyticals && item.category === 'Analytics')
          return (document.cookie = `${item.key_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`)
        if (!acceptedCookies.needed && item.category === 'Preferences')
          return (document.cookie = `${item.key_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`)
        if (!acceptedCookies.functionals && item.category === 'Functional')
          return (document.cookie = `${item.key_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`)
        return ''
      })
    }
  }, [
    acceptedCookies.analyticals,
    acceptedCookies.functionals,
    acceptedCookies.marketing,
    acceptedCookies.needed,
    understood,
  ])

  if (!understood)
    return (
      <Container>
        <Wrapper>
          <p>
            Utilizamos cookies para proporcionar aos nossos usuários a melhor experiência no nosso
            site. Você pode entender melhor sobre a utilização de cookies pelo Direção Concursos e
            como desativá-los em
            <Link to="/privacidade"> saiba mais</Link>.
          </p>
          <button onClick={() => dispatch(changeUnderstood(true))}>Aceitar e sair</button>
        </Wrapper>
        {/* {openModal && (
          <CookiebarModal openModal={() => setOpenModal(!openModal)} />
        )} */}
      </Container>
    )

  return <div />
}

export default CookieBar
